import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import useIntl from '@afosto/utils-react/intl/useIntl';
import translations from './translations';

export const PaymentProviderCardSkeleton = props => (
  <Grid item xs={12} {...props}>
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Typography variant="subtitle1">
              <Skeleton variant="text" width={120} />
            </Typography>
            <Typography variant="caption" color="textSecondary">
              <Skeleton variant="text" width={75} />
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Grid>
);

const PaymentProviderCard = ({ item, onClick }) => {
  const intl = useIntl();

  return (
    <Grid item xs={12}>
      <Card>
        <CardActionArea onClick={onClick}>
          <CardContent>
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography variant="subtitle1">{item.name}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {item.code}
                </Typography>
              </Box>
              {!item.is_active && (
                <Chip
                  variant="outlined"
                  size="small"
                  label={intl.formatMessage(translations.badge.inactive)}
                  color="secondary"
                />
              )}
              {item.is_active && !item.is_configured && (
                <Chip
                  variant="outlined"
                  size="small"
                  label={intl.formatMessage(translations.badge.incomplete)}
                  color="secondary"
                />
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

PaymentProviderCard.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
};

PaymentProviderCard.defaultProps = {
  item: null,
  onClick: undefined,
};

export default PaymentProviderCard;
